/**
 * オブジェクトや配列の順序に依存しないdeep equalなシリアライズ
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function stableStringify(obj: any): string {
    if (Array.isArray(obj)) {
        return `[${obj.map(stableStringify).join(',')}]`;
    } else if (obj && typeof obj === 'object') {
        return `{${Object.keys(obj).sort().map(k => JSON.stringify(k) + ':' + stableStringify(obj[k])).join(',')}}`;
    } else {
        return JSON.stringify(obj);
    }
}

/**
 * pointFeatures配列から、以下の条件で重複を省いた配列を返す
 * ・propertiesの値が全て一致する
 * ・_geometryの値が全て一致する
 * ・layer.idが一致する
 * @param features - MapGeoJSONFeature配列
 * @returns 重複を除いたfeatures配列
 */
export const uniqueFeatures = (features: maplibregl.MapGeoJSONFeature[]): maplibregl.MapGeoJSONFeature[] => {
    const seen = new Set<string>();
    const result: maplibregl.MapGeoJSONFeature[] = [];
    for (const feature of features) {
        const layerId = feature.layer?.id ?? '';
        // Polygon-outlineを含むlayer.idは除外
        if (layerId.includes('Polygon-outline')) continue;
        const key =
            stableStringify(feature.properties || {}) +
            '|' +
            stableStringify(feature._geometry || {}) +
            '|' +
            layerId;
        if (!seen.has(key)) {
            seen.add(key);
            result.push(feature);
        }
    }
    return result;
};
